<template>
  <li class="thing-item">
    <div class="top"
         :class="{'top_open': open}"
         @click="open = !open">
      <p class="thing-name">
        <span v-if="project.parent">
          {{$t('projects.project.project')}}:
        </span>
        <span v-else>
          {{$t('projects.project.projectItem')}}:
        </span>
          {{project.name}}
      </p>

      <chevron-icon :class="{'opened': open}"
                    :fill="'#109CF1'"></chevron-icon>
    </div>
    <transition name="fade">
      <div class="bottom" v-show="open">
        <permission-toggler @level="changePermission($event)"
                            :default-val="project.level"></permission-toggler>
      </div>
    </transition>
  </li>
</template>

<script>
  import chevronIcon from '../../../Svg/chevronIcon'
  import permissionToggler from '../../../permissionToggler'
  import {mapActions} from 'vuex'
  import {tokenAndRoute} from "../../../../mixins/utils/tokenAndRoute";
  import {loaderMixin} from "../../../../mixins/utils/loaderMixin";

  export default {
    name: 'roleInfoThing',
    props: {
      project: {
        type: Object
      }
    },
    mixins: [tokenAndRoute, loaderMixin],
    components: {
      chevronIcon,
      permissionToggler
    },
    data() {
      return {
        open: false,
      }
    },
    methods: {
      ...mapActions({
        setPermissions: 'projects/setPermissions',
        getProjects: 'projects/getProjects',
      }),
      async changePermission(level) {
        let changedId = this.project.id;
        let parent = this.project.parent;

        let data = {
          value: level,
          roles_ids: `${this.routeId}`
        };

        if (parent) {
          data.project_id = changedId
        } else {
          data.project_item_id = changedId
        }

        this.showLoader()
        await this.setPermissions({data});
        await this.getProjects()
        this.hideLoader()
      }
    }
  }
</script>

<style lang="scss" scoped>
  svg {
    transition: $anim;
  }

  .opened {
    transform: rotate(180deg);
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 20px 30px;
    transition: $anim;
    border: 1px solid $grey;
    border-radius: 6px;
    margin-bottom: 2px;
    font-family: $mm;
    font-size: 14px;
    letter-spacing: .25px;
    color: $lightBlue;
    cursor: pointer;
  }

  .top_open {
    border-color: white;
    box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
  }

  .bottom {
    margin: 20px 7px;
  }
</style>
